module.exports = __webpack_public_path__ + "b6331b12b6ad3710a844ff817660c61c.svg";